import React from "react";
import { observer } from "mobx-react";
import { withStyles } from "@material-ui/styles";
import Layout from "../../components/Layout";
import LocationCreate from "./LocationCreate";
import LocationList from "./LocationList";
const styles = (theme) => ({
  tableContainer: {
    marginTop: 20,
  },
});

const View = observer(
  class Location extends React.Component {
    render() {
      return (
        <Layout>
          {/* <LocationCreate /> */}
          <LocationList />
        </Layout>
      );
    }
  }
);

export default withStyles(styles)(View);
